define(
    ['text!./templates/mfp-select-dealer.html'],
    templateStr => [
        () => { // NOSONAR
            return {
                restrict: 'E',
                scope: {
                    dealer: '=', //view model!
                    brandCode: '@',
                },
                template: templateStr,
                controller: [
                    '$scope',
                    'BaslerDealerSearchService',
                    ($scope, BaslerDealerSearchService) => {
                        $scope.callGroups = 'dealerSearch';
                        $scope.dealersLoaded = false;

                        BaslerDealerSearchService.getDealersForBrand($scope.callGroups, $scope.brandCode)
                            .then((dealers) => {
                                $scope.dealers = dealers;
                                $scope.dealersLoaded = true;
                            });

                        $scope.vm = {
                            inputString: '',
                        };
                        const dealerFieldsToFilter = [
                            'name',
                            'addressLine1',
                            'addressLine2',
                            'postCode',
                            'city',
                            'dealerCode',
                        ];

                        $scope.searchDealer = (userInput) => {
                            if (!userInput) {
                                return $scope.dealers;
                            }

                            /**
                             * Filter Dealers:
                             * If every given string (splitted at space) matches at least one of the fields in a Dealer
                             * include that Dealer in the list.
                             */
                            return $scope.dealers.filter(dealer =>
                                userInput.toLowerCase().split(' ').every((lowerCaseInput) => {
                                    return dealerFieldsToFilter.some((dealerField) => {
                                        const actField = dealer[dealerField];
                                        return actField && actField.toLowerCase().includes(lowerCaseInput);
                                    });
                                }));
                        };

                        $scope.onDealerSelected = (dealer) => {
                            $scope.vm.inputString = dealer.name;
                            $scope.dealer.value = dealer;
                        };

                        $scope.unselectDealer = () => {
                            $scope.dealer.value = {};
                        };
                    },
                ],
            };
        },
    ]
);


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPSelectDealer.js